import styled from "styled-components/macro";
import {Button} from "@chakra-ui/react";
import Container from "../../components/container";
import HeaderData from "../../components/header_data";
import NavLink from "../../components/nav_link";
import {themecolors} from "../../utils/themecolors";

const Content = styled.div``;

const PageNotFound = styled(({className}) => {
    return (
        <>
            <HeaderData title={`404`}/>
            <Container className={className}>
                <Content>
                    <h1>Page not found.</h1>
                    <p>You may have followed a broken link.</p>
                    <NavLink href={'/'} react_route>
                        <Button variant='blue' mt={'24px'}>Go home</Button>
                    </NavLink>
                </Content>
            </Container>
        </>
    );
})`
  ${Content} {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    flex-direction: column;
  }

  p {
    font-size: 15px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  h1 {
    font-size: 20px !important;
  }

`;

export default PageNotFound;
